import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { SkillsComponent } from './skills/skills.component';
import { PodcastsComponent } from './podcasts/podcasts.component';
import { AwardsComponent } from './awards/awards.component';
import { NavigationComponent } from './navigation/navigation.component';
import {FormsModule} from '@angular/forms';
import { FilterPipe } from './filter.pipe';
import {LoggingService} from './logging.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SanitizerPipe } from './sanitizer.pipe';
import { ChessComponent } from './chess/chess.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {LichessInterceptor} from './chess/lichess.interceptor';
import {ShortenPipe} from './shorten.pipe';
import { TextAnalyticsComponent } from './text-analytics/text-analytics.component';
import {RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings} from 'ng-recaptcha';
import {DataService} from './shared/data.service';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { RevealDirective } from './shared/reveal.directive';

@NgModule({ declarations: [
        AppComponent,
        AboutComponent,
        SkillsComponent,
        PodcastsComponent,
        AwardsComponent,
        NavigationComponent,
        FilterPipe,
        SanitizerPipe,
        ShortenPipe,
        ChessComponent,
        TextAnalyticsComponent,
        RevealDirective
    ],
    bootstrap: [AppComponent], imports: [BrowserModule, FormsModule, ClipboardModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }), RecaptchaModule, RecaptchaFormsModule], providers: [DataService, LoggingService,
        { provide: HTTP_INTERCEPTORS, useClass: LichessInterceptor, multi: true },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: '6LdTO5kUAAAAAPTMMauDBNiBfsOnnA6fcdVg_EOh',
            } as RecaptchaSettings,
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
